import { Edit, Box, TextField } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = Yup.object({
  name: Yup.string().trim().required(),
  active_bot: Yup.number().required(),
  maximum_port_balance: Yup.number().required(),
  allow_exclusive_bot: Yup.string().trim().required(),
});

interface formDataType {
  name: string;
  active_bot: number;
  maximum_port_balance: number;
  allow_exclusive_bot: string;
}
export const TierEdit = () => {
  const {
    saveButtonProps,
    register,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  return (
    <Edit canDelete={false} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("tier_id")}
          required
          error={!!(errors as any)?.tier_id}
          helperText={(errors as any)?.tier_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Tier_id"
          name="tier_id"
          disabled
        />
        <TextField
          {...register("name")}
          required
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />
        <TextField
          {...register("active_bot")}
          required
          error={!!(errors as any)?.active_bot}
          helperText={(errors as any)?.active_bot?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="Active_bot"
          name="active_bot"
        />
        <TextField
          {...register("maximum_port_balance")}
          required
          error={!!(errors as any)?.maximum_port_balance}
          helperText={(errors as any)?.maximum_port_balance?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="Maximum_port_balance"
          name="maximum_port_balance"
        />
        <TextField
          {...register("allow_exclusive_bot")}
          required
          error={!!(errors as any)?.allow_exclusive_bot}
          helperText={(errors as any)?.allow_exclusive_bot?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="Allow_exclusive_bot"
          name="allow_exclusive_bot"
        />
      </Box>
    </Edit>
  );
};
